<mat-card class="cur-card" formGroupName="supplyresumptionResultInfo">
    <mat-card-content>

        <div *ngIf="sagyoshubetsuCD == '2'; then generalResumptionSupply; else simplifiedResumptionSupply"></div>

        <!-- 一般供給再開 -->
        <ng-template #generalResumptionSupply>
            <div class="tw-flex tw-flex-row tw-flex-wrap" style="margin-left: 5px; overflow: auto;">
                <canvas placeholder="署名入力エリア" #signCanvas [width]="canvasSize.w" [height]="canvasSize.h"
                    style="border:1px solid #c3c3c3;" id="signCanvas">
                </canvas>

                <mat-card-actions style="margin-left: 40px; margin-top: 10px;"
                    class="account-button tw-flex tw-content-end">
                    <button type="button" (click)="setDrawState()" mat-raised-button color="primary" id="clearButton"
                        class="btn">クリア</button>
                </mat-card-actions>
            </div>

            <div style="margin-left: 5px;">
                <mat-radio-group color="warn" class="search-condition-radio-frame" [value]="signatureDivValue"
                    style="height: 50px; width: 400px; position: relative;border: none;" formControlName="signatureDiv">
                    <mat-radio-button class="radio-button-margin" [value]="code.userCode"
                        *ngFor="let code of codeMap?.get('S001020')">{{code.hyojiCont}}</mat-radio-button>

                </mat-radio-group>
            </div>
            <div class="tw-flex tw-flex-col tw-flex-wrap" style="margin-left: 5px; overflow: auto;" *ngIf="finalConfirmTab.signatureImage">
                <mat-label>保存済みお客さま署名</mat-label>
                <div class="image-frame">
                    <img [src]="signatureImg" [width]="canvasSize.w" [height]="canvasSize.h"
                    style="border: 1px solid #bdbdbd;" id="signImage"/>
                </div>
            </div>
        </ng-template>

        <!-- 簡易供給再開 -->
        <ng-template #simplifiedResumptionSupply>
            <div style="width: 400px; margin-top: 2%; margin-left: 2%;">
                <mat-checkbox class="check-box" color="primary" [checked]="flyerPostingFlg"
                    (change)="flyerPostingFlg = $event.checked" id="flyerPostingFlg"
                    [disabled]="getControl('flyerPostingFlg')?.disabled">チラシ投函 *
                </mat-checkbox>
            </div>
        </ng-template>
        <mat-card-actions>
        </mat-card-actions>

    </mat-card-content>
</mat-card>